import api from "@/lib/api";

// Fire-and-forget first-party analytics. Never blocks the UI; failures are swallowed.
export function track(event, props = {}) {
  api.post("/analytics/track", { event, props }).catch(() => {});
}

// Map a route path to a module_open event (for module usage / funnels).
const PATH_MODULE = {
  "/dashboard": "dashboard", "/ai": "ai", "/formation": "formation", "/credit": "credit",
  "/funding": "funding", "/documents": "documents", "/contracts": "contracts",
  "/education": "education", "/progress": "progress", "/portal": "portal",
};

export function trackRoute(pathname) {
  if (pathname === "/dashboard" || pathname === "/") {
    track("dashboard_view", { path: pathname });
    return;
  }
  const mod = PATH_MODULE[pathname];
  if (mod) track("module_open", { module: mod, path: pathname });
}
